<mjx-navigator [hide]="hideNavbar">
  <router-outlet></router-outlet>
  <div class="footer" (click)="openDialog()">
    {{ getFooter() }}
  </div>
</mjx-navigator>
